<template>
  <ModalView />
  <div class="container-super" @keypress='managerTT(statusContinue = false)' @click='managerTT(statusContinue = false)'
    v-if="counter > 0 && counter <= 3">
    <NavigationView :headerModel="headerModel" />
    <section class="container-fluid" v-class="{ containerSucces: counter === 3 && success }">
      <DataForTutorView v-if="counter === 1" v-on:eventEmit="continuity" v-on:eventEmitBack="recedeMain" />
      <QueryOptionsView v-else-if="counter === 2" v-on:eventEmit="continuity" :responsePeriodos="responsePeriodos"
        v-on:eventEmitBack="recedeMain" />
      <AlertServiceView v-else-if="counter === 3 && success" :emailSend="emailSend" @salir="handleSalir" />
    </section>
  </div>
</template>

<script async setup>
import {
  ref,
  onBeforeMount,
  onMounted,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router';
import NavigationView from '@/core/components/NavigationView.vue';
import TITLES from '@/core/constants/titles';
import TYPEHEADER from '@/core/constants/typeHeader';
import useUtils from '@/core/utils/utils';
import ws from '@/core/constants/ws';
import SessionDataService from '@/core/services/sessionDataService';
import modelModal from '@/core/models/ModelModal';
import AlertServiceView from '@/core/components/AlertServiceView.vue';
import DataForTutorView from './DataForTutorView.vue';
import QueryOptionsView from './QueryOptionsView.vue';

const headerModel = ref({
  type: TYPEHEADER.TYPEHEADER.success,
  text: TITLES.TITLES.titleDataForTutor,
  image: '',
});

const emit = defineEmits(['back'])
const router = useRouter()
const route = useRoute()

const responsePeriodos = ref(null);
const counter = ref(1);
const emailSend = ref('');
const success = ref(false);
const store = useStore();
const propertiesModal = ref(null);
const objSession = new SessionDataService();

// ── Mapeo paso → ruta ────────────────────────────────────────
const STEP_ROUTES = {
  1: 'tutorDatos',
  2: 'tutorOpciones',
  3: 'tutorExito',
}

// ── Mapeo ruta → paso ────────────────────────────────────────
const ROUTE_STEPS = {
  tutorDatos: 1,
  tutorOpciones: 2,
  tutorExito: 3,
}

function navigateToStep(step) {
  const routeName = STEP_ROUTES[step]
  if (routeName && route.name !== routeName) {
    router.push({ name: routeName })
  }
}

function limpiarSesion() {
  SessionDataService.dataSession = null;
  SessionDataService.flagSessionActivate = false;
  localStorage.removeItem('mngr');
  sessionStorage.removeItem('exitoEmail');
}

onBeforeMount(() => {
  const stepFromRoute = ROUTE_STEPS[route.name] || 1
  counter.value = stepFromRoute
  success.value = false
  emailSend.value = ''

  // ✅ Restaurar estado de éxito desde sessionStorage — sin exponer email en URL
  if (route.name === 'tutorExito') {
    const emailGuardado = sessionStorage.getItem('exitoEmail')
    if (emailGuardado) {
      success.value = true
      emailSend.value = emailGuardado
      counter.value = 3
      sessionStorage.removeItem('exitoEmail') // limpiar después de leer
    }
  }

  store.dispatch('showModalWarning', {})
})

onMounted(() => {
  propertiesModal.value = modelModal.modelModal;
  localStorage.clear();
});

// ✅ Limpiar sesión al salir del flujo por botón atrás del navegador
onBeforeRouteLeave(to => {
  const esRutaDelFlujo = ['tutorDatos', 'tutorOpciones', 'tutorExito'].includes(to.name)
  if (!esRutaDelFlujo) {
    limpiarSesion()
  }
})

const managerTT = (statusContinue) => {
  objSession?.initGetActivityUserTime();
  if (statusContinue) {
    localStorage.setItem('mngr', +new Date().getTime());
  } else if (localStorage.getItem('mngr') !== null && localStorage.getItem('mngr') !== '') {
    localStorage.setItem('mngr', +new Date().getTime());
  }
};

function recedeMain(e) {
  if (e) {
    if (counter.value === 1) {
      counter.value = 0
      limpiarSesion()
      emit('back')
      router.push({ name: 'landing' })
      return
    }
    SessionDataService.dataSession = null;
    SessionDataService.flagSessionActivate = false;
    headerModel.value = {
      type: TYPEHEADER.TYPEHEADER.success,
      text: TITLES.TITLES.titleDataForTutor,
      image: '',
    };
    counter.value -= 1;
    localStorage.removeItem('mngr');
    navigateToStep(counter.value)
  }
}

async function valideTutor(modelRequestVT) {
  store.commit('showSpinner');
  const dataRequest = { data: modelRequestVT, context: 'tutor' };
  const responseValideTutor = await store.dispatch('callService', dataRequest);
  store.commit('hideSpinner');
  return responseValideTutor;
}

async function getPeriods(modelRequestPeriods) {
  store.commit('showSpinner');
  const dataRequest = { data: modelRequestPeriods, context: 'periodo' };
  const responseGetPeriods = await store.dispatch('callService', dataRequest);
  store.commit('hideSpinner');
  return responseGetPeriods;
}

async function sendStatus(modelRequestSS) {
  store.commit('showSpinner');
  const dataRequest = { data: modelRequestSS, context: 'correo' };
  const responseSS = await store.dispatch('callService', dataRequest);
  store.commit('hideSpinner');
  return responseSS;
}

async function validTokenRecaptcha(token) {
  store.commit('showSpinner');
  const dataRequest = { data: token, context: 'captcha' };
  const responseValidaToken = await store.dispatch('callService', dataRequest);
  store.commit('hideSpinner');
  return responseValidaToken;
}

async function continuity(event) {
  const { continueFlow } = event;
  if (continueFlow) {
    const { componentName } = event;
    const { data } = event;

    switch (componentName) {
      case 'ebuuvups': {
        const modelRequestVT = {
          idCanal: ws.DEFAULT_CHANNEL,
          curp: data.curp,
          correo: data.correo,
          token: data.token,
        };

        const resolveServiceTutor = await valideTutor(modelRequestVT);

        if (resolveServiceTutor.codigoOperacion) {
          SessionDataService.initSession(resolveServiceTutor.datosSalida.tutor);
          SessionDataService.setUpdateSession('curp', modelRequestVT.curp);

          const modelRequestP = {
            idCanal: ws.DEFAULT_CHANNEL,
            idPais: ws.DEFAULT_COUNTRY,
            telefono: SessionDataService.dataSession.telefono,
          };

          const resolveGetPeriods = await getPeriods(modelRequestP);

          if (resolveGetPeriods.codigoOperacion) {
            managerTT(resolveServiceTutor.codigoOperacion);
            SessionDataService.setUpdateSession('correo', modelRequestVT.correo);
            const readPeriods = resolveGetPeriods.datosSalida.periodos;
            readPeriods.forEach((element, index) => {
              readPeriods[index].mes = useUtils.resolveMonth(element.mes);
            });
            responsePeriodos.value = readPeriods;
            headerModel.value = {
              type: TYPEHEADER.TYPEHEADER.success,
              text: TITLES.TITLES.titleQueryOptions,
              image: '',
            };
            counter.value += 1;
            navigateToStep(counter.value)
          } else {
            propertiesModal.value = {
              showModal: true,
              routeRedirection: '',
              message: resolveGetPeriods.mensaje,
              textButton: 'Reintentar',
            };
            store.dispatch('showModalWarning', propertiesModal.value);
          }
        } else {
          propertiesModal.value = {
            showModal: true,
            routeRedirection: '',
            message: resolveServiceTutor.mensaje,
            textButton: 'Reintentar',
          };
          store.dispatch('showModalWarning', propertiesModal.value);
        }
        break;
      }

      case 'rvfszpqu': {
        const modelRequestSSA = {
          idPais: ws.DEFAULT_COUNTRY,
          idCanal: ws.DEFAULT_CHANNEL,
          tipoConsulta: data.tipoConsulta,
          periodo: data.periodo,
          correo: SessionDataService.dataSession.correo,
          telefono: SessionDataService.dataSession.telefono,
          nombre: SessionDataService.dataSession.nombre,
          apellidoPaterno: SessionDataService.dataSession.apellidoPaterno,
          apellidoMaterno: SessionDataService.dataSession.apellidoMaterno,
          curp: SessionDataService.dataSession.curp,
        };

        const resolveSendStatus = await sendStatus(modelRequestSSA);

        if (resolveSendStatus.codigoOperacion) {
          const emailMasked = useUtils.maskEmail(SessionDataService.dataSession.correo);
          localStorage.removeItem('mngr');
          headerModel.value = {
            type: TYPEHEADER.TYPEHEADER.success,
            text: TITLES.TITLES.ready,
            image: '',
          };
          counter.value = 3;
          success.value = true;
          // ✅ Asignar directamente el ref — el componente se reutiliza
          // entre pasos (no se vuelve a montar al pasar de 2 a 3), así que
          // onBeforeMount no se vuelve a ejecutar y el email nunca se
          // leería de sessionStorage a tiempo. Sin esta línea se muestra
          // "sin correo" en AlertServiceView.
          emailSend.value = emailMasked;
          // ✅ Guardar también en sessionStorage — cubre el caso de refresh
          // de página en /estado_cuenta_menores/exito, donde sí se remonta
          sessionStorage.setItem('exitoEmail', emailMasked);
          // ✅ flagSession sigue true para que el guard permita tutorExito
          router.push({ name: 'tutorExito' })
        } else {
          success.value = false;
          propertiesModal.value = {
            showModal: true,
            routeRedirection: '',
            message: resolveSendStatus.mensaje,
            textButton: 'Reintentar',
          };
          store.dispatch('showModalWarning', propertiesModal.value);
        }
        break;
      }

      default:
        break;
    }
  }
}

function handleSalir() {
  counter.value = 0
  limpiarSesion() // ← limpia sesión y sessionStorage cuando el usuario sale
  emit('back')
  router.push({ name: 'landing' })
}

watch(
  () => store.state.paramsModalError,
  modal => {
    if (modal.showModal && modal.routeRedirection !== '') {
      counter.value = 0
      store.dispatch('managerModal', {})
      limpiarSesion()
      emit('back')
      router.push({ name: 'landing' })
    }
  }
)
</script>

<style scoped>
.container-fluid {
  width: 100%;
  margin: auto;
  margin-top: 50px;
  height: calc(100% - 325px);
  display: block;
}

.containerSucces {
  margin-top: 0px;
  height: calc(100% - 175px);
}

@media only screen and (min-width:300px) and (max-width: 740px) and (min-height: 540px) and (max-height: 915px) and (orientation:portrait) {
  .container-fluid {
    display: flex;
    justify-content: center;
    margin: auto;
    margin-top: 50px;
    align-items: flex-start;
    height: auto;
  }
}

@media only screen and (min-width:568px) and (max-width:568px) and (orientation:landscape) {
  .container-fluid {
    display: inline-flex;
    height: auto;
  }
}

@media only screen and (min-width: 567px) and (max-width: 1025px) and (min-height: 300px) and (max-height: 730px) and (orientation: landscape) {
  .container-fluid {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    height: auto;
  }
}
</style>